import axios from 'axios';

const BASE_URL =
  process.env.REACT_APP_WOOCOMMERCE_BASE_URL ||
  'https://server.chancellorswaypharmacy.com/wp-json/wc/v3';

// WooCommerce Api Endpoint added with api security keys
export const wooCommerceRequest = axios.create({
  auth: {
    username: process.env.REACT_APP_CONSUMER_KEY,
    password: process.env.REACT_APP_CONSUMER_SECRET,
  },
  baseURL: BASE_URL,
});
